import Tippy from "@tippyjs/react";
import React, { useEffect, useState } from "react";

const Likes = ({
  like,
  classes = "dark:bg-jacarta-700 absolute top-3 right-3 flex items-center space-x-1 rounded-md bg-white p-2",
}) => {
  const initialLikeCount =
    typeof like === "string" ? parseInt(like) || 0 : like || 0;
  const [likeCount, setLikeCount] = useState(initialLikeCount);
  const [isLiked, setIsLiked] = useState(false);

  const handleLike = () => {
    if (isLiked) {
      setLikeCount((prev) => Math.max(0, prev - 1));
      setIsLiked(false);
    } else {
      setLikeCount((prev) => prev + 1);
      setIsLiked(true);
    }
  };

  return (
    <div
      className={`${classes} min-w-0 flex-shrink-0 flex items-center gap-1`}
      onClick={handleLike}
    >
      <Tippy content={<span>{isLiked ? "Unlike" : "Like"}</span>}>
        <button className="js-likes relative cursor-pointer flex items-center justify-center flex-shrink-0">
          {isLiked ? (
            <svg
              className="w-4 h-4 text-red-500 fill-current flex-shrink-0"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                clipRule="evenodd"
              />
            </svg>
          ) : (
            <svg
              className="w-4 h-4 text-jacarta-500 dark:text-jacarta-200 hover:text-red-500 dark:hover:text-red-500 flex-shrink-0"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                clipRule="evenodd"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              />
            </svg>
          )}
        </button>
      </Tippy>
      <span className="dark:text-jacarta-200 text-jacarta-700 dark:text-white text-sm font-medium whitespace-nowrap">
        {likeCount}
      </span>
    </div>
  );
};

export default Likes;
